/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	createSelector,
	createFeatureSelector,
	ActionReducerMap,
	ActionReducer,
	MetaReducer,
	Action,
} from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as fromRouter from '@ngrx/router-store';
import * as fromSettings from './settings/reducers';
import * as fromUser from './user/reducers';
import { AppState, AppStateSettings } from '@app/store/settings/AppState';

export const reducers: ActionReducerMap<any> = {
	router: fromRouter.routerReducer,
	settings: fromSettings.reducer,
	devsettings: fromSettings.devReducer,
	appstatesettings: fromSettings.appStateSettingsReducer,
	appstate: fromSettings.appStateReducer,
	user: fromUser.reducer
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
	return (state: any, action: any): any => {
		return reducer(state, action)
	}
}

export const metaReducers: MetaReducer<any>[] = !environment.production
	? [logger]
	: [];

export const getSettingsState = createFeatureSelector<any>('settings');
export const getSettings = createSelector(
	getSettingsState,
	fromSettings.getSettings
);

export const getDeveloperSettingsState = createFeatureSelector<fromSettings.DeveloperSettings>('devsettings');
export const getDeveloperSettings = createSelector(
	getDeveloperSettingsState,
	fromSettings.getDevSettings
);
export const getAppStateSettingsState = createFeatureSelector<AppStateSettings>('appstatesettings');
export const getAppStateSettings = createSelector(
	getAppStateSettingsState,
	fromSettings.getAppStateSettings
);
export const getActiveProjectID = createSelector(
	getAppStateSettingsState,
	fromSettings.getActiveProjectID,
);

export const getAppStateState = createFeatureSelector<AppState>('appstate');
export const getActiveProject = createSelector(
	getAppStateState,
	fromSettings.getActiveProject
);
export const getActiveParticipant = createSelector(
	getAppStateState,
	fromSettings.getActiveParticipant
);

export const getUserState = createFeatureSelector<fromUser.UserState>('user');
export const getUser = createSelector(getUserState, fromUser.getUser);
